import * as React from 'react';
import {useContext, useEffect, useState} from 'react';
import {DefaultButton, Dropdown, Panel, PanelType, PrimaryButton, SpinButton, Stack, TextField} from '@fluentui/react';
import AuthContext from "../../Services/AuthContext";

function AddProjectCounter(props) {
    const [user] = useContext(AuthContext);
    const [number, setNumber] = useState('');
    const [value, setValue] = useState(0);
    const [counter, setCounter] = useState(null);
    const [counters, setCounters] = useState([]);

    const _submit = (e) => {
        e.preventDefault();
        const data = {counter_id: counter.key, number: number, value: value};
        fetch(`/api/project/${props.add}/counter`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(json => { props.onSuccess(json); props.dismissPanel(); })
            .catch(err => { console.log(err) })
    }

    useEffect(() => {
        const abortController = new AbortController();
        if (props.add) {
            setValue(0);
            setNumber('');
            setCounter(null);
            async function fetchCounters() {
                await fetch(`/api/counter`, {
                    method: 'GET',
                    signal: abortController.signal,
                    headers: {
                        'Authorization': 'Bearer ' + user.token
                    }
                }).then(res => res.json())
                    .then(data => {
                        setCounters(data.map((item) => {
                            return {key: item.id, text: item.name};
                        }))
                    })
                    .catch(err => {
                        console.log(err)
                    })
            }
            fetchCounters();
        }
        return () => abortController.abort();
    }, [props.add, user.token])

    const footer = React.useCallback(() => (<Stack horizontal horizontalAlign='space-between'>
        <PrimaryButton type='submit' form='AddProjectCounter'>Dodaj</PrimaryButton>
        <DefaultButton onClick={props.dismissPanel}>Anuluj</DefaultButton>
    </Stack>), [props.dismissPanel]);

    return (
        <Panel
            isOpen={props.add}
            onDismiss={props.dismissPanel}
            type={PanelType.medium}
            headerText="Dodaj Licznik"
            closeButtonAriaLabel="Close"
            onRenderFooterContent={footer}
            isFooterAtBottom={true}
        >
            <form onSubmit={_submit} id='AddProjectCounter'>
                <Dropdown
                    label="Licznik"
                    selectedKey={counter ? counter.key : undefined}
                    onChange={(e, item) => setCounter(item)}
                    placeholder="Wybierz z listy"
                    options={counters}
                />
                <TextField label='Numer' value={number} onChange={(e) => setNumber(e.target.value || '')}/>
                <SpinButton
                    label={'Wartość:'}
                    labelPosition={'top'}
                    min={0}
                    max={1000000}
                    step={0.01}
                    incrementButtonAriaLabel={'Increase value by 1'}
                    decrementButtonAriaLabel={'Decrease value by 1'}
                    value={value}
                    onChange={(e) => setValue(e.target.value || '')}
                />
            </form>
        </Panel>
    )
}

export default AddProjectCounter;